import { EasingFunctions, animation } from '../../../../utility/via-anim';
import { diagramPaddingPx } from '../../../../components/diagram/diagram-util';


const diagramAnimation = (svgEl) => {
  if (!svgEl) throw new Error('svgEl is not the required type.');

  const initialBox = {
    x: svgEl.viewbox().x,
    y: svgEl.viewbox().y,
    width: svgEl.viewbox().width,
    height: svgEl.viewbox().height,
  };

  const currentBox = { ...initialBox };

  const goalBox = {
    x: svgEl.viewbox().x,
    y: svgEl.viewbox().y,
    width: svgEl.viewbox().width,
    height: svgEl.viewbox().height,
  };

  const diagramAnim = animation((progress) => {
    const p = EasingFunctions.easeInQuad(progress); // Eases the rate at which 'progress' changes.

    // Calculate the intermediate position of the viewbox.
    const newViewBox = {
      x: currentBox.x + (p * (goalBox.x - currentBox.x)),
      y: currentBox.y + (p * (goalBox.y - currentBox.y)),
      width: currentBox.width + (p * (goalBox.width - currentBox.width)),
      height: currentBox.height + (p * (goalBox.height - currentBox.height)),
    };

    // Update the real view box with the new coordinates.
    svgEl.viewbox(newViewBox);
  });

  return {
    /**
     * Sets the destination bbox for when the diagram viewbox changes.
     * @param {object} bbox An SVG bbox object.
     */
    setGoalBox(bbox, includePadding = true) {
      goalBox.x = bbox.x - (includePadding ? diagramPaddingPx : 0);
      goalBox.y = bbox.y - (includePadding ? diagramPaddingPx : 0);
      goalBox.width = bbox.width + (includePadding ? (diagramPaddingPx * 2) : 0);
      goalBox.height = bbox.height + (includePadding ? (diagramPaddingPx * 2) : 0);
    },

    /**
     * Starts the animation. This will move the diagram to the goal box that has been set.
     * @param {number} durationMs The time in ms that the animation will take.
     */
    start(durationMs = 600) {
      // Re-init the current view box co-ordinates where we currently are.
      currentBox.x = svgEl.viewbox().x;
      currentBox.y = svgEl.viewbox().y;
      currentBox.width = svgEl.viewbox().width;
      currentBox.height = svgEl.viewbox().height;

      diagramAnim.start(durationMs);
    },

    /**
     * Cancels the current animation.
     * This will do nothing if no animation is currently running.
     */
    cancel() {
      diagramAnim.cancel();
    },
  };
};

export default diagramAnimation;
